import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Typography, CircularProgress, useTheme } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { withNamespaces } from "react-i18next";

import { ReactComponent as CheckMarkIconSvg } from "../../assets/certified.svg";

import Web3 from "web3";
import { toFixed, tokens } from "../../constants/constants";
import bigInt from "big-integer";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: "30px",
    fontFamily: "Poppins",
    background: theme?.colors.poolCard?.backgroundColor,
    boxShadow: "0px 3px 20px " + theme?.colors?.containerShadow,
    cursor: "pointer",
  },
  titleName: {
    position: "absolute",
    top: "10px",
    left: "0.8rem",
    color: theme?.colors.poolCard?.titleSecondary,
    cursor: "pointer",
    fontSize: "1.2rem",
    fontWeight: "600",
    textShadow: "#474747 2px 2px 2px",
    "&:hover": {
      opacity: "0.8",
    },
  },
  topPoolType: {
    minWidth: "80px",
    paddingLeft: "5px",
    paddingRight: "5px",
    height: "24px",
    borderRadius: "16px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.colors.poolCard?.poolTypeText,
    whiteSpace: "nowrap",
  },

  poolHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
  },

  poolContent: {
    display: "flex",
    flexDirection: "column",
    padding: "16px 24px 32px",
    gap: "0.8rem",
  },
  poolBgImage: {
    zIndex: 3,
    position: "absolute",
    width: "100%",
    height: "100%",
    left: "0px",
    right: "0px",
    top: "0px",
    bottom: "0px",
    opacity: "0.3",
  },
  poolDefaultImage: {
    width: "100%",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    height: "300px",
    objectFit: "cover",
    boxShadow: "0px 3px 20px " + theme?.colors?.containerShadow,
  },
  avatarLogo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginRight: "0.6rem",
  },
  checkMarkIcon: {
    marginLeft: "8px",
    width: "20px",
    height: "20px",
    color: theme?.colors.poolCard?.linkIcon,
  },
  poolTitle: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    fontSize: "20px",
    color: theme?.colors.poolCard?.textSecondary,
    cursor: "pointer",
    fontWeight: "600",
    width: "100%",
  },
  saleTitleStyle: {
    fontSize: "20px",
    color: theme?.colors.poolCard?.textSecondary,
    cursor: "pointer",
    fontWeight: "600",
    width: "100%",
    margin: "0",
  },

  poolDescription: {
    fontWeight: "normal",
    fontSize: "16px",
    color: "#A0A0A0",
  },
  per1BNB: {
    fontSize: "15px",
    lineHeight: "18px",
    color: theme?.colors.poolCard?.title,
    marginBottom: "8px",
  },
  saleValue: {
    fontSize: "25px",
    fontWeight: "normal",
    lineHeight: "30px",
    letterSpacing: "0px",
    textAlign: "left",
    minHeight: "30px",
    color: theme?.colors.poolCard?.textSecondary,
    marginBottom: "15px",
  },
  saleStatusContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "25px",
  },
  salesStatusBar: {
    marginRight: "10px",
    width: "100%",
    height: "16px",
    borderRadius: "12px",
    backgroundColor: theme?.colors?.presale?.percentageBarBackground,
    marginBottom: "8px",
  },
  salesStatusSubBar: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  salesStatusBarFilled: {
    height: "16px",
    borderRadius: "12px",
  },
  salesStatusText: {
    fontSize: "15px",
    color: theme?.colors.poolCard?.statusBarLabel,
    whiteSpace: "nowrap",
    marginRight: "8px",
  },
  salesRequiredText: {
    fontSize: "15px",
    color: theme?.colors.poolCard?.statusBarLabel,
    marginBottom: "25px",
  },
  maximumConnectContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginRight: "20px",
  },
  maximumWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  connectWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  maximumConnectLabel: {
    fontSize: "15px",
    lineHeight: "18px",
    color: theme?.colors.poolCard?.title,
    marginBottom: "8px",
  },
  maximumValue: {
    fontSize: "20px",
    lineHeight: "24px",
    color: theme?.colors.poolCard?.textSecondary,
  },
  connectIconsWrapper: {
    display: "flex",
    "& > *": {
      width: "24px",
      height: "24px",
      color: theme?.colors.poolCard?.linkIcon,
      marginRight: "20px",
      "&:hover": {
        color: theme?.colors.poolCard?.linkIconHover,
      },
      cursor: "pointer",
    },
  },
  poolPercentageText: {
    color: theme?.colors?.poolCard?.statusBarLabel,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: theme?.colors?.presale?.loadingBackground,
    zIndex: 4,
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  loadingIcon: {
    zIndex: 5,
    color: theme?.colors?.presale?.loadingIcon,
    position: "absolute",
    top: "100px",
    left: "50%",
  },
  badge: {
    marginLeft: "0.6rem",
    width: "30px",
    height: "30px",
  },
  presaleStatus: {
    display: "flex",
    gap: "4px",
    flexDirection: "column",
  },
  dotSeparator: {
    width: "100%",
    flex: "1",
    borderBottom: "2px dotted " + theme?.colors?.presale?.divider,
    marginBottom: "6px",
  },
  poolSubInfoCard: {
    display: "flex",
    width: "100%",
    gap: "5px",

    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  poolSubInfoHeading: {
    color: theme?.colors?.presale?.cardText,
    fontWeight: "normal",
    lineHeight: "normal",
    marginBottom: "0px",
    cursor: "default",

    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
    transition: "all 0.3s ease",

    "&:hover": {
      textDecoration: "underline",
      color: theme?.colors?.home?.infoBoxDescription,
    },
  },

  poolSubInfoValue: {
    color: theme?.colors?.presale?.cardText,
    fontWeight: "600",
    lineHeight: "normal",
    textAlign: "right",
    fontSize: "13px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "140px",
    },
  },

  poolTokenAddress: {
    color: theme?.colors?.presale?.addressValueText,
    fontSize: "12px",
    fontWeight: 600,
    [theme.breakpoints.up("sm")]: {
      fontSize: "15px",
    },
    "&:hover": {
      opacity: 0.6,
    },
  },
  poolTokenSymbolLink: {
    textDecoration: "none",
  },
});

const CompletedProjectCard = ({ classes, pool }) => {
  const history = useHistory();
  const theme = useTheme();
  const web3 = new Web3();

  const [logoImage, setLogoImage] = useState("pools/default.png");
  const [altImg, setAltImg] = useState("pools/default.png");

  useEffect(() => {
    const loadLogo = () => {
      try {
        const parsedLogo = web3.utils.hexToUtf8(pool.linkLogo);
        setLogoImage(parsedLogo);
      } catch (err) {
        console.error(err);
        setLogoImage(pool.linkLogo); // assume it's already parsed
      }

      setAltImg(pool.linkImgMain); // assume it's already parsed
    };

    loadLogo();
  }, [pool.linkLogo, pool.linkImgMain, web3.utils]);

  return (
    <div
      className={classes.root}
      onClick={() => {
        if (pool.url) history.push(pool.url);
      }}
    >
      {/* <Typography
        variant="p"
        className={classes.titleName}
        onClick={() => {
          history.push(pool.url);
        }}
      >
        {pool.saleTitle}
      </Typography> */}

      {!pool.saleTitle ||
        (!parseInt(pool.openTime) && (
          <div className={classes.loadingContainer}>
            <CircularProgress className={classes.loadingIcon} size={60} />
          </div>
        ))}
      <img
        className={classes.poolDefaultImage}
        src={altImg}
        alt="pool"
        onError={(er) => {
          setAltImg("pools/default.svg");
        }}
      />
      <div className={classes.poolContent}>
        <div className={classes.poolHeader}>
          <Typography
            variant="h3"
            className={classes.poolTitle}
            onClick={() => {
              history.push(pool.url);
            }}
          >
            <img
              className={classes.avatarLogo}
              src={logoImage}
              alt="pool"
              onError={(er) => {
                setLogoImage("pools/default.svg");
              }}
            />

            <p className={classes.saleTitleStyle}>
              {pool.saleTitle}
              <span>
                {pool.certified && (
                  <Tooltip title="Certified BUIDLer">
                    <CheckMarkIconSvg className={classes.checkMarkIcon} />
                  </Tooltip>
                )}
              </span>
            </p>
          </Typography>
        </div>
        {pool.description && (
          <Typography variant="p" className={classes.poolDescription}>
            {pool.description.split(" ").length > 8
              ? pool.description.split(" ").slice(0, 8).join(" ") + "..."
              : pool.description}
          </Typography>
        )}
        <div className={classes.presaleStatus}>
          <div className={classes.poolSubInfoCard}>
            <Typography variant="h5" className={classes.poolSubInfoHeading}>
              Token
            </Typography>
            <div className={classes.dotSeparator} />
            <a
              className={classes.poolTokenSymbolLink}
              href={theme?.blockExplorer + "token/" + pool?.tokenAddress}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography variant="h5" className={classes.poolTokenAddress}>
                ${pool?.tokenSymbol}
              </Typography>
            </a>
          </div>

          <div className={classes.poolSubInfoCard}>
            <Typography variant="h5" className={classes.poolSubInfoHeading}>
              Raised
            </Typography>
            <div className={classes.dotSeparator} />
            <Typography variant="h5" className={classes.poolSubInfoValue}>
              {toFixed(
                bigInt(pool?.totalCollectedWei || "0"),
                pool?.fundingTokenDecimals ?? 18,
                3
              )}{" "}
              {tokens[pool?.fundingTokenAddress].label}
            </Typography>
          </div>
          <div className={classes.poolSubInfoCard}>
            <Typography variant="h5" className={classes.poolSubInfoHeading}>
              Participants
            </Typography>
            <div className={classes.dotSeparator} />
            <Typography variant="h5" className={classes.poolSubInfoValue}>
              {pool?.totalInvestorsCount ?? "0"}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(CompletedProjectCard))
);
